import api from './api'

const url = '/me'

export const getMe = async (data) =>
    api({
        url,
        data,
    });